module.exports = __webpack_public_path__ + "assets/img/logo.646282a.png";